import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navlight from "./Navlight";
import LogoLight from "../../app/assets/images/logo-light.png";
import LogoDark from "../../app/assets/images/logo-dark.png";

//form
import BookMeeting from "../../components/pages/Form/bookmeeting";

const HeaderOne = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const openMenu = () => {
    setIsMenuOpen(true);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <header className="header-style-1">
        <div
          className={`header-navbar navbar-sticky custom-light-header ${
            windowWidth <= 991 ? "mobile-menu" : ""
          }`}
        >
          <div className="container custom-cn-width">
            <div className="d-flex align-items-center justify-content-between pdt-12 cp-min-pd">
              <div className="site-logo">
                <Link to="/">
                  <img
                    width={230}
                    src={LogoLight}
                    alt="Logo"
                    class="img-fluid lg-display-light"
                  />
                </Link>
                <Link to="/">
                  <img
                    width={230}
                    src={LogoDark}
                    alt="Logo"
                    class="img-fluid lg-display-dark d-none"
                  />
                </Link>
              </div>

              <div className="offcanvas-icon d-block d-xl-none">
                <a href="#" onClick={openMenu} className="nav-toggler">
                  <i className="fal fa-bars"></i>
                </a>
              </div>

              <nav
                className={`site-navbar ms-auto ${isMenuOpen ? "menu-on" : ""}`}
              >
                <Navlight />

                {isMenuOpen && (
                  <a href="#" onClick={closeMenu} className="nav-close">
                    <i className="fal fa-times"></i>
                  </a>
                )}
                <div className="header-btn" style={{ marginTop: "-4px" }}>
                  <button
                    type="button"
                    className="btn cust-btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#meeting"
                  >
                    BOOK A MEETING
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>

      <div
        className="modal fade"
        id="meeting"
        tabindex="-1"
        aria-labelledby="apply-modal"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Book a meeting </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-4">
              <BookMeeting />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderOne;
